// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { ReplySupport, uploadFile } from '../../../apis/base';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { replySupportActions } = actionCreatorsList;

const outputActions = {
  success: replySupportActions.success,
  failure: replySupportActions.failure
};

type RequestActionTypes = ActionType<
  typeof replySupportActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const replySupportEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(replySupportActions.request)
    ),
    switchMap(async (action: RequestActionTypes) => {
      const { message, id, imagesFiles } = action.payload;
      const imagesUrls = [];
      if (imagesFiles?.length) {
        for (const imageFile of imagesFiles) {
          const { fileName, upload } = await uploadFile(imageFile);
          await upload;
          imagesUrls.push(fileName)
        }
      }

      return ReplySupport(
        message,
        imagesUrls,
        id
      ).then((data) => {
        return outputActions.success({data: data.data});
      }).catch((error: AxiosError) => {
        console.log(error)
        return outputActions.failure({ error });
      });
    })
  );
};

export { replySupportEpic as default};
